import styled, { css, RuleSet } from 'styled-components'

import { spin } from '@/theme/animations'

import {
  BorderLoaderAlignKeys,
  BorderLoaderColor,
  BorderLoaderSizeKeys,
} from './border-loader.types'

export const BorderLoader = styled.div<{
  $align: BorderLoaderAlignKeys
  $size: BorderLoaderSizeKeys
  $color: BorderLoaderColor
}>(({ theme, $align, $size, $color }) => {
  const baseStyles = css`
    aspect-ratio: 1 / 1;
    width: 2rem;
    border: ${theme.border.size['3']} dashed ${$color};
    border-radius: ${theme.border.radius.circle};
    animation: ${spin} 2s linear infinite;
  `

  const alignStyles: Record<BorderLoaderAlignKeys, RuleSet> = {
    'absolute-center': css`
      position: absolute;
      inset: 0;
      margin: ${theme.space.auto};
    `,
    center: css`
      align-self: center;
      margin: ${theme.space['0']} ${theme.space.auto};
    `,
    unset: css``,
  }

  const sizeStyles: Record<BorderLoaderSizeKeys, RuleSet> = {
    'extra-small': css`
      width: 1.6rem;
      border-width: ${theme.border.size['1']};
    `,
    large: css`
      width: 2.4rem;
      border-width: ${theme.border.size['4']};
    `,
    medium: css`
      width: 2rem;
      border-width: ${theme.border.size['3']};
    `,
    small: css`
      width: 1.6rem;
      border-width: ${theme.border.size['2']};
    `,
    unset: css``,
  }

  return css`
    ${baseStyles}
    ${alignStyles[$align]}
    ${sizeStyles[$size]}
  `
})
